// src/hooks/useFavorites.js
import { useSelector, useDispatch } from 'react-redux';
import { getFavorites, addToFavorites, removeFromFavorites, checkFavorite } from '../store/favoritesSlice.js';

export const useFavorites = () => {
  const dispatch = useDispatch();
  const { items, isLoading, error } = useSelector((state) => state.favorites);

  const handleGetFavorites = () => dispatch(getFavorites());
  const handleAddToFavorites = (productId) => dispatch(addToFavorites(productId));
  const handleRemoveFromFavorites = (productId) => dispatch(removeFromFavorites(productId));
  const handleCheckFavorite = (productId) => dispatch(checkFavorite(productId));

  return {
    items,
    isLoading,
    error,
    getFavorites: handleGetFavorites,
    addToFavorites: handleAddToFavorites,
    removeFromFavorites: handleRemoveFromFavorites,
    checkFavorite: handleCheckFavorite,
  };
};